import { generateUrlParams } from "../../utils/generateUrlParams";

const baseUrl = "Faculty";

export const getFacultiesUrl = () => `${baseUrl}/get-all-faculties`;
export const getAllDeansUrl = (filter) =>
	`${baseUrl}/all-deans?${generateUrlParams(filter)}`;
export const assignDeantoFacultyUrl = () => `${baseUrl}/assigndeantofaculty`;
export const bulkFacultiesUploadUrl = () => `${baseUrl}/upload-faculties`;
export const createFacultyUrl = () => `${baseUrl}/create-faculty`;
export const deleteFacultyUrl = (id) =>
	`${baseUrl}/delete-faculty?facultyId=${id}`;
export const downloadFacultyExcelTemplateUrl = () =>
	`${baseUrl}/download-faculty-upload-template`;
export const getAllPaginatedFacultiesUrl = (filter) =>
	`${baseUrl}/all-faculties-paginated?${generateUrlParams(filter)}`;
export const getApplicationFacultiesUrl = (applicationTypeId) =>
	`${baseUrl}/${applicationTypeId}/application-faculty`;
export const toggleFacultyActivationStatusUrl = (id) =>
	`${baseUrl}/faculty/${id}/toggle-activation`;
export const updateFacultyUrl = () => `${baseUrl}/update-faculty`;
